import { render, staticRenderFns } from "./SearchBody.container.vue?vue&type=template&id=19cc6da7&"
import script from "./SearchBody.container.vue?vue&type=script&lang=ts&"
export * from "./SearchBody.container.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBody.container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports